export interface CommunityWriteUpsParams {
  page: number;
  limit: number;
  sort?: string;
  searchText?: string;
}

export enum WriteUpStatus {
  PENDING = 0,
  ACCEPTED = 1,
  REJECTED = 2,
}
